"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconStyles = void 0;
const lit_1 = require("lit");
const utils_1 = require("@/utils");
const iconSizeTokens = {
    tiny: { 'font-size': '0.75rem' },
    small: { 'font-size': '0.875rem' },
    large: { 'font-size': '1.5rem' },
};
exports.iconStyles = (0, lit_1.css) `
  :host {
    display: inline-flex;
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
  }

  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('size', iconSizeTokens, '.icon'))}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaWNvbi5zdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpY29uLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBb0M7QUFJcEMsbUNBQW1FO0FBS25FLE1BQU0sY0FBYyxHQUFpRDtJQUNuRSxJQUFJLEVBQUUsRUFBRSxXQUFXLEVBQUUsU0FBUyxFQUFFO0lBQ2hDLEtBQUssRUFBRSxFQUFFLFdBQVcsRUFBRSxVQUFVLEVBQUU7SUFDbEMsS0FBSyxFQUFFLEVBQUUsV0FBVyxFQUFFLFFBQVEsRUFBRTtDQUNqQyxDQUFBO0FBRVksUUFBQSxVQUFVLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7OztJQVl6QixJQUFBLGVBQVMsRUFBQyxJQUFBLDJCQUFtQixFQUFDLE1BQU0sRUFBRSxjQUFjLEVBQUUsT0FBTyxDQUFDLENBQUM7Q0FDbEUsQ0FBQSJ9